// extracted by mini-css-extract-plugin
export default {"container":"editCancelButtons_container__Xu7Q+"};